import { AxiosResponse } from 'axios'
import { http } from '../realisations/Http.realisation'
import { CreateProposalPayload, GetProposalByIdResponseT, GetProposalFilters, GetProposalResponseT } from '../types/proposal.types'

export class ProposalRepository {
    getProposal(filters: GetProposalFilters): Promise<AxiosResponse<GetProposalResponseT>> {
        return http.get('/cabinet/api/proposals', { params: filters })
    }

    createProposal(payload: CreateProposalPayload): Promise<AxiosResponse<void>> {
        return http.post('/cabinet/api/proposals', payload)
    }

    getProposalById(proposal_id: number): Promise<AxiosResponse<GetProposalByIdResponseT>> {
        return http.get(`/cabinet/api/proposals/${proposal_id}`)
    }

    updateProposal(proposal_id: number, payload: CreateProposalPayload): Promise<AxiosResponse<void>> {
        return http.put(`/cabinet/api/proposals/${proposal_id}`, payload)
    }

    deleteProposal(proposal_id: number): Promise<AxiosResponse<void>> {
        return http.delete(`/cabinet/api/proposals/${proposal_id}`)
    }

    closeProposal(proposal_id: number): Promise<AxiosResponse<void>> {
        return http.put(`/cabinet/api/proposals/${proposal_id}/processed`, {})
    }
}
